import {MainGrid} from 'components/atoms/Layout/MainGrid';
import {BRFLabel} from 'components/molecules/Banners/BRFLabel';
import {EcoLabel} from 'components/molecules/Banners/EcoLabel';
import * as React from 'react';

import {getFormattedMessage} from 'features/services/utils/language-helper';

import './_labels.scss';

interface Props {
    swanLabel: boolean;
    swanPageUrl?: string;
    safeBrf: boolean;
}

export const LabelSection: React.FunctionComponent<Props> = ({swanLabel, swanPageUrl, safeBrf}) => {
    return (
        <MainGrid fullwidth className="label-section">
            {swanLabel &&
                <div className="project-label">
                    <EcoLabel
                        url={swanPageUrl ? swanPageUrl : ""}
                        headline={getFormattedMessage('jm.components.StagePage.swanHeadline')}
                    />
                </div>
            }
            {safeBrf &&
                <div className="project-label">
                    <BRFLabel headline={getFormattedMessage('jm.components.StagePage.brfLabelHeadline')} />
                </div>
            }
        </MainGrid>
    )
};
